<template>
    <vx-modal :visible="props.visible"
        @update:visible="emit('update:visible', $event)"
        :padding="false"
        size="md">
        <template v-slot:header>
            <div class="px-6 pt-6">
                <slot name="header">
                    Preview Message
                </slot>
            </div>
        </template>

        <template v-if="$slots.subheader" v-slot:subheader>
            <div class="px-6">
                <slot name="subheader"></slot>
            </div>
        </template>

        <div class="p-6">
            <message-cloud fullWidth :message="messageData" :showDetails="false" />
        </div>

        <template v-if="$slots.footer"
            v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <slot name="footer"></slot>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxModal } from '@voxie/frontend-components';
import MessageCloud from '~/components/messages/browser-extension/components/misc/MessageCloud.vue';
import { computed } from 'vue';

const props = defineProps({
    visible: Boolean,
    message: {
        type: Object,
        required: true,
        default: () => ({})
    },
});

const emit = defineEmits(['update:visible']);

const messageData = computed(() => ({
    direction: 'outbound',
    body: props.message.body,
    media_url: props.message.mediaUrl,
    media_content_type: props.message.mediaContentType,
}));
</script>
